/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

//misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';

const BotDeploymentsInstagramStrategyGeneralForm = ({ form, hasEditAccess }) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();
  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Row>
          <Col flex="auto">
            <Typography.Text>
              {t('Application Settings')}
            </Typography.Text>

            <Typography.Paragraph className="fs-sm" type="secondary">
              {t('Configure the application settings')}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Form.Item
          label={t('Page Access Token')}
          name={[...FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH, 'pageAccessToken']}
          rules={[{
            required: true,
            message: t('Please input Page Access Token')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter page access token')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH, 'pageAccessToken'])}</Typography.Text>
          }
        </Form.Item>

        <Form.Item
          label={t('Page ID')}
          name={[...FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH, 'fbConnectedPageId']}
          rules={[{
            required: true,
            message: t('Please input Page ID')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Page ID')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH, 'pageId'])}</Typography.Text>
          }
        </Form.Item>

        <Form.Item
          label={t('App Secret')}
          name={[...FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH, 'appSecret']}
          tooltip={t('Facebook App Secret used to verify webhook signatures (X-Hub-Signature-256). If not set, webhook payloads are accepted without verification.')}
        >
          {
            hasEditAccess
              ? <Input.Password placeholder={t('Enter Facebook App Secret')} />
              : <Typography.Text>{'••••••••'}</Typography.Text>
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsInstagramStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};

export default BotDeploymentsInstagramStrategyGeneralForm;
